import { config } from "@config/index";

const ZENDESK_API_KEY = config.ZENDESK_API_KEY;

const integrations = {
  ZENDESK_API_KEY,
};

export default integrations;
